import { BrowserRouter } from "react-router-dom"
import { Container } from "./styles"
import ScrollAnimation from "react-animate-on-scroll"
import Illustration from "../../assets/illustration.svg"
import { NavHashLink } from "react-router-hash-link"
import linkedin from '../../assets/linkedin.svg'
import githubIcon from '../../assets/github.svg'

import Hello from '../../assets/Hello.gif'

export function Hero() {
  return (
    <Container id="home">
      <div className="hero-text">
        <ScrollAnimation animateIn="fadeInUp">
          <p>Hello <img src={Hello} alt="Hello" width="20px"/>, I'm</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.2 * 1000}>
          <h1>Pushpraj majhi</h1>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.4 * 1000}>
          <h3>Software Engineer</h3>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.6 * 1000}>
          <p className="small-resume">1 Year Experience in bubble.io at Zstudioo</p>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={0.8 * 1000}>
          <BrowserRouter>
            <NavHashLink smooth to="#contact" className="button">Contact</NavHashLink>
          </BrowserRouter>
        </ScrollAnimation>
        <ScrollAnimation animateIn="fadeInUp" delay={1 * 1000}>
      <div className="social-media">
  <a
    href="https://www.linkedin.com/in/pushpraj-majhi-2a0930279/"
    target="_blank"
    rel="noreferrer"
  >
    <img src={linkedin} alt="Linkedin" />
  </a>
  <a
    href="https://github.com/Pushprajmajhi65"
    target="_blank"
    rel="noreferrer"
  >
    <img src={githubIcon} alt="GitHub" />
  </a>
  <a
    href="https://instagram.com/your_instagram_username"
    target="_blank"
    rel="noreferrer"
    style={{ display: "inline-block", width: 24, height: 24, verticalAlign: "middle" }}
  >
    {/* Instagram SVG icon */}
    <svg role="img" viewBox="0 0 24 24" width="24" height="24" fill="#E4405F" xmlns="http://www.w3.org/2000/svg">
      <title>Instagram</title>
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.334 3.608 1.308.974.974 1.246 2.241 1.308 3.608.058 1.266.069 1.646.069 4.85s-.011 3.584-.069 4.85c-.062 1.366-.334 2.633-1.308 3.608-.974.974-2.241 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.011-4.85-.069c-1.366-.062-2.633-.334-3.608-1.308-.974-.974-1.246-2.241-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.334-2.633 1.308-3.608C4.515 2.497 5.782 2.225 7.148 2.163 8.414 2.105 8.794 2.094 12 2.094zm0-2.163C8.741 0 8.332.013 7.052.072 5.771.131 4.659.417 3.678 1.398c-.98.98-1.267 2.092-1.326 3.373C2.013 5.668 2 6.077 2 9.335v5.33c0 3.258.013 3.667.072 4.947.059 1.281.346 2.393 1.326 3.373.98.98 2.092 1.267 3.373 1.326 1.28.059 1.689.072 4.947.072s3.667-.013 4.947-.072c1.281-.059 2.393-.346 3.373-1.326.98-.98 1.267-2.092 1.326-3.373.059-1.28.072-1.689.072-4.947v-5.33c0-3.258-.013-3.667-.072-4.947-.059-1.281-.346-2.393-1.326-3.373-.98-.98-2.092-1.267-3.373-1.326C15.668.013 15.259 0 12 0zm0 5.838a6.162 6.162 0 1 0 0 12.324 6.162 6.162 0 0 0 0-12.324zm0 10.162a3.999 3.999 0 1 1 0-7.998 3.999 3.999 0 0 1 0 7.998zm6.406-11.845a1.44 1.44 0 1 0 0 2.88 1.44 1.44 0 0 0 0-2.88z"/>
    </svg>
  </a>
</div>
        </ScrollAnimation>
      </div>
      <div className="hero-image">
        <ScrollAnimation animateIn="fadeInRight" delay={1 * 1000}>
          <img src={Illustration} alt="Ilustração" />
        </ScrollAnimation>
      </div>
    </Container>
  )
}